<template>
  <div class="course-detail-header">
    <div class="wrapper">
      <div class="course-title font-semibold">
        {{ course.pageTitle }}
      </div>
      <div class="detail-wrap">
        <Material class="material-wrapper" :video-url="course.video" :img-url="course.img" @open-video="openVideo" />
        <div class="course-detail">
          <div>
            <div class="title font-semibold text-overflow-ellipsis">
              {{ course.detailTitle }}
            </div>
            <div class="text">
              <div v-for="(item,index) in course.description" :key="index" class="text-box">
                <div class="outline-title text-overflow-ellipsis font-semibold ">
                  {{ item.mainTitle }}
                </div>
                <div class="content text-overflow-ellipsis font-medium">
                  {{ item.subTitle }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="course.outline" class="outline-preview" @click="outlineVisible = true">
            <img v-lazy-load v-lazy-load :data-src="course.outline" class="outline-img">
            <div class="outline-mask">
              <div class="outline-mask-btn">
                <i class="el-icon-zoom-in" />
                View Syllabus
              </div>
            </div>
          </div>
          <el-dialog :visible.sync="outlineVisible" append-to-body :show-close="false" custom-class="dialog-outline" top="86px">
            <img v-lazy-load :data-src="course.outline" class="outline-dialog-img">
            <div class="outline-dialog-footer">
              <button class="download-btn" @click="downloadOutline">
                <i class="el-icon-download" /> Download
              </button>
            </div>
          </el-dialog>
          <div class="button-box" :class="{ 'hide-price': hidePriceLabel }">
            <div class="desc-tag">
              <span v-if="$t('courses.courseCard.lowPricePrefix')" class="from-title font-semibold">{{ $t('courses.courseCard.lowPricePrefix') }}:</span><span class="price">{{ lowestPrice==='--'?'--': `${ currency }${filters.priceUnitConvert(lowestPrice, minorUnit, isKeepTwoDecimal)}` }}<span v-if="showPerLowestPrice" class="per-lesson-text">{{ $t('courses.perLesson' ) }}</span></span>
              <span v-if="$t('courses.courseCard.lowPriceTailfix')" class="from-title font-semibold">{{ $t('courses.courseCard.lowPriceTailfix') }}</span>
            </div>
            <button class="button course-button" @click="signUpHandle">
              {{ btnText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import skrollTop from 'skrolltop';
import filters from 'common/filters.js';
import Material from './Material'

export default {
  components: {
    Material,
  },
  props: {
    showPerLowestPrice: {
      default: false,
      type: Boolean,
    },
    lowestPrice: {
      type: [String, Number],
      default: '--',
    },
    courseDateStart: {
      type: String,
      default: '--',
    },
    courseDateEnd: {
      type: String,
      default: '--',
    },
    banner: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    course: {
      type: Object,
      default: () => {},
    },
    openVideo: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      filters,
      isKeepTwoDecimal: this.$t('common.isKeepTwoDecimal'),
      termStr: '',
      timer: null,
      btnText: 'Book Now',
      outlineVisible: false,
    }
  },
  computed: {
    minorUnit() {
      return this.$store.state.currency.minorUnit;
    },
    currency() {
      return this.$store.state.currency.symbol
    },
    hidePriceLabel() {
      return this.course.showPrice === false || this.lowestPrice === '--' || Number(this.lowestPrice) === 0
    },
  },
  watch: {
    list: {
      handler(val) {
        const nameArr = val.map((item) => item.name)
        this.termStr = nameArr.join('、')
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async downloadOutline() {
      try {
        const res = await fetch(this.course.outline)
        const blob = await res.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = this.course.outline.split('/').pop() || 'syllabus'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        window.open(this.course.outline, '_blank')
      }
    },
    signUpHandle() {
      if (document.getElementsByClassName('uk-filters').length) {
        const { top } = document.getElementsByClassName('uk-filters')[0].getBoundingClientRect()
        skrollTop.scrollTo({
          to: top - 100,
        });
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.course-detail-header {
  background: #fff;
  margin: 0 auto;
  margin-bottom: 50px;
  padding: 60px 0;

  .course-title {
    font-size: 38px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 45px;
    margin-bottom: 30px;
  }

  .detail-wrap {
    display: flex;
    align-items: center;

    .text-box {
      margin-bottom: 12px;
    }

    .material-wrapper {
      width: 560px;
      height: 420px;
      margin-right: 80px;
    }

    .course-detail {
      display: flex;
      flex-direction: column;
      align-items: baseline;
      height: 420px;

      .title {
        font-size: 30px;
        font-weight: 600;
        color: var(--txt-color-lv1);
        line-height: 36px;
        margin-bottom: 20px;
        width: 600px;
      }

      .outline-title {
        font-size: 20px;
        font-weight: 600;
        color: var(--txt-color-link);
        line-height: 24px;
        width: 600px;
      }

      .content {
        padding-top: 4px;
        font-size: 20px;
        font-weight: 500;
        color: var(--txt-color-lv1);
        line-height: 24px;
        width: 600px;
      }

      .outline-preview {
        flex: 1;
        min-height: 0;
        width: 360px;
        margin-bottom: 16px;
        border-radius: 10px;
        overflow: hidden;
        cursor: zoom-in;
        position: relative;

        .outline-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center -37px;
          display: block;
        }

        .outline-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;

          .outline-mask-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 24px;
            border: 2px solid #fff;
            border-radius: 100px;
            background: rgba(0, 0, 0, 0.3);
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            font-family: 'Poppins', sans-serif;

            .el-icon-zoom-in {
              font-size: 20px;
            }
          }
        }
      }

      .button-box {
        margin-top: auto;
        width: 360px;
        height: 151px;
        background: var(--txt-color-link3);
        border-radius: 12px;
        position: relative;

        .desc-tag {
          padding: 22px 20px 0 22px;
          color: var(--txt-color-link);
          display: flex;
          justify-content: space-between;

          .from-title {
            font-size: 20px;
            line-height: 24px;
          }

          .price {
            font-size: 26px;
            line-height: 31px;

            .per-lesson-text {
              font-size: 12px;
              font-weight: 600;
              line-height: 14px;
            }
          }
        }

        .course-button {
          position: absolute;
          bottom: 0;
          height: 80px;
          width: 100%;
          background: var(--txt-color-link);
          border-radius: 12px;
          text-align: center;
          font-size: 30px;
          color: #fff;
          line-height: 80px;
          cursor: pointer;
        }

        &:hover {
          background: var(--txt-color-link4);
        }
      }

      .hide-price {
        height: 80px;

        .desc-tag {
          display: none;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dialog-outline {
  width: fit-content !important;
  background: transparent !important;
  box-shadow: none !important;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    background: transparent;
  }

  .outline-dialog-img {
    display: block;
    max-width: 100%;
    max-height: 74vh;
    height: auto;
    margin: 0 auto;
  }

  .outline-dialog-footer {
    padding: 24px 0 0 0;
    text-align: center;
  }

  .download-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 24px;
    border: 2px solid #fff;
    border-radius: 100px;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
  }
}
</style>
